import '../filter_view.js.coffee';# Added by Script 
import './published_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.FacebookPublishedFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/published/published_filter"]

  events:
    'click .apply': 'apply'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @socialNetwork = 'facebook'
    @publishedSource = 'published'

  render: ->
    @$el.html(@template(@, publishedSource: @publishedSource))
    @

  getFilterValue: =>
    filterValue = @$el.find('input[type="radio"]:checked').val()
    return @getBooleanOf(filterValue)

  getBooleanOf: (value) ->
    return value unless value?
    value == 'true'

  apply: =>
    console.log "Filter Value: #{@getFilterValue()}"
    @searchQuery.setFbIsPublished(@getFilterValue())
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
